import { createBrowserRouter, Navigate } from 'react-router-dom';
import Home from '../pages/Home/Home';
import Services from '../pages/Services/Services';
import About from '../pages/About/About';
import Contact from '../pages/Contact/Contact';
import { Team } from '../pages/Team/Team';
import Layout from '../pages/Layout/Layout';
import NotFound from '../pages/NotFound/NotFound';
import { Cases } from '../pages/Cases/Cases';
import Compliance from '../pages/Compliance/Compliance';
import Login from '../pages/Login/Login';
import ValidationLogin from '../pages/ValidationLogin/ValidationLogin';
import Marketplace from '../pages/marketplace/Marketplace';
import Assets from '../components/AssetsComponent/Assets';

export const router = createBrowserRouter([
    { path: '.', element: <Navigate to="/home" replace /> },
    { path: '/', element: <Navigate to="/home" replace /> },
    {
        path: '/home',
        element: (
            <Layout>
                <Home />
            </Layout>
        ),
    },
    {
        path: '/servicos',
        element: (
            <Layout>
                <Services />
            </Layout>
        ),
    },
    {
        path: '/equipe',
        element: (
            <Layout>
                <Team />
            </Layout>
        ),
    },

    {
        path: '/quem-somos',
        element: (
            <Layout>
                <About />
            </Layout>
        ),
    },
    {
        path: '/sucessos',
        element: (
            <Layout>
                <Cases />
            </Layout>
        ),
    },
    {
        path: '/contato',
        element: (
            <Layout>
                <Contact />
            </Layout>
        ),
    },

    {
        path: '/compliance',
        element: (
            <Layout>
                <Compliance />
            </Layout>
        ),
    },
    {
        path: '/login',
        element: (
            <Layout>
                <Login />
            </Layout>
        ),
    },
    {
        path: '/login/validacao',
        element: (
            <Layout>
                <ValidationLogin />
            </Layout>
        ),
    },
    {
        path: '/marketplace',
        element: <Marketplace />,
    },

    {
        path: '/images',
        element: <Assets />,
    },

    // 👇 Rota wildcard para lidar com URLs inexistentes
    {
        path: '*',
        element: (
            <Layout>
                <NotFound />
            </Layout>
        ),
    },
]);
